import { type IconName, useDynamicSvg } from 'hooks/useDynamicSvg'
import { type FC } from 'react'

type IconProps = {
  className?: string
  fill?: string
  href?: string
  name: IconName
  rel?: string
  size?: number | string
  stroke?: string
  strokeWidth?: number
  target?: string
  onClick?: () => void
}

const Icon: FC<IconProps> = ({
  name,
  size = 16,
  href,
  fill,
  stroke,
  strokeWidth,
  className,
  onClick,
  target,
  rel,
}) => {
  const { loading, error, SvgIcon } = useDynamicSvg(name)

  if (error || loading) return null

  return (
    <>
      { SvgIcon && (
        href != null
          ? (
              <a href={ href }
                rel={ rel }
                target={ target }
              >
                <SvgIcon
                  className={ className }
                  data-testid={ `${name}-icon` }
                  fill={ fill }
                  height={ size }
                  stroke={ stroke }
                  strokeWidth={ strokeWidth }
                  width={ size }
                  onClick={ onClick }
                />
              </a>
            )
          : (
              <SvgIcon
                className={ className }
                data-testid={ `${name}-icon` }
                fill={ fill }
                height={ size }
                stroke={ stroke }
                strokeWidth={ strokeWidth }
                width={ size }
                onClick={ onClick }
              />
            )
      )}
    </>
  )
}

export default Icon
